export default function ErrorState({ error }: { error: string }) {
  return (
    <div className="w-full flex items-center justify-center py-8">
      <p className="text-sm text-destructive">Hata: {error}</p>
    </div>
  );
}
